var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, InsertLinkOutlined, MoreVert, Search } from "@mui/icons-material";
import { Backdrop, Chip, CircularProgress, Grid, IconButton, MenuItem, Select, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { v4 } from "uuid";
import { CrossSvgIcon, DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../assets/customIcons";
import { SearchIcon } from "../../../assets/images";
import { MuiStack } from "../../../builderPackage/components";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { EDashboardStatusColor, LOCAL_STORAGE_KEYS } from "../../../constants";
import { showNotification } from "../../../redux/commonSlice";
import { resetState, setReducerState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { faintblue } from "../../../theme/palette";
import { getStatusColor } from "../../../theme/statusColors";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate, isLoadingState } from "../../../utils/utils";
import { isNullOrEmpty } from "../../../utils/validationHelper";
import { BasicDetailcards } from "../components/basicDetailCards";
import CardSummury from "../components/cardSummury";
import { spareIssuePartElements } from "../components/partElements";
import SavedSuccessfullyPopup from "../components/savedSuccessfullyPopup";
import SpareIssuePartGrid from "../components/spareIssuePartGrid";
import { getFilterTypeList, getPartDetailsAPICall, getSearchResultAPIcall, getWarehouseListAPICall, spareIssueCreateAPICall } from "../services/apiCalls";
import { APIKeys, SEMandatoryFields, SpareIssuesKeys, SpareIssueStatusEnum } from "../services/entity";
import { getGeneralDetails, getSearchDisable, getSpareIssueDetails } from "../utils/utils";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import ActionMenuList from "../../../builderPackage/components/actionsMenuList";
import { Delete } from "../../../builderPackage/assets/svg";
export var CreateSpareIssues = function () {
    var _crud$SpareIssuesKeys, _crud$SpareIssuesKeys2, _crud$SpareIssuesKeys3, _crud$SpareIssuesKeys9, _user$data$GivenName, _user$data, _user$data$FamilyName, _user$data2, _crud$SpareIssuesKeys10, _crud$SpareIssuesKeys11, _crud$SpareIssuesKeys12, _installbaseData$, _crud$SpareIssuesKeys13, _crud$SpareIssuesKeys14, _crud$SpareIssuesKeys15, _crud$SpareIssuesKeys16, _crud$SpareIssuesKeys17, _crud$SpareIssuesKeys18, _crud$SpareIssuesKeys19, _crud$SpareIssuesKeys20, _crud$SpareIssuesKeys21, _crud$SpareIssuesKeys22, _crud$SpareIssuesKeys23, _crud$SpareIssuesKeys24, _crud$SpareIssuesKeys25, _crud$SpareIssuesKeys26, _crud$SpareIssuesKeys27, _crud$SpareIssuesKeys28, _crud$SpareIssuesKeys29, _crud$SpareIssuesKeys30, _crud$SpareIssuesKeys31, _crud$SpareIssuesKeys32, _getSearchByTypeList$, _getSearchByTypeList$2, _crud$SpareIssuesKeys34;
    var crud = useAppSelector(function (state) { return state.crud; });
    var getSearchByTypeList = crud.getSearchByTypeList;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var user = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var isMulitpleDoc = getLocalStorageItem(LOCAL_STORAGE_KEYS.SPARE_ISSUE_MULTIPLE_DOC);
    var _a = useState(false), onSavePopup = _a[0], setOnSavePopup = _a[1];
    var _b = useState(false), isFormVisible = _b[0], setIsFormVisible = _b[1];
    var _c = useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = useState({}), partData = _d[0], setPartData = _d[1];
    var _e = useState(), installbaseData = _e[0], searchedIstallbaseData = _e[1];
    var _f = useState("All"), filterType = _f[0], setFilterType = _f[1];
    var _g = useState(''), searchValue = _g[0], setSearchValue = _g[1];
    var data = (_crud$SpareIssuesKeys = (_crud$SpareIssuesKeys2 = crud[SpareIssuesKeys.JobcardDetails]) === null || _crud$SpareIssuesKeys2 === void 0 ? void 0 : _crud$SpareIssuesKeys2.data) !== null && _crud$SpareIssuesKeys !== void 0 ? _crud$SpareIssuesKeys : (_crud$SpareIssuesKeys3 = crud[SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys3 === void 0 ? void 0 : _crud$SpareIssuesKeys3.data;
    var isSearchDisabled = getSearchDisable(filterType, searchValue);
    var searchParams = useSearchParams()[0];
    var _h = useParams(), id = _h.id, tenantId = _h.tenantId;
    var mode = searchParams.get('mode');
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var isDisable = !isFormVisible || isMulitpleDoc && mode == 'edit' || data == SpareIssueStatusEnum.Issued || data == SpareIssueStatusEnum.PartiallyReturned || data == SpareIssueStatusEnum.Returned || data == SpareIssueStatusEnum.Cancelled || data == SpareIssueStatusEnum.Closed;
    var searchType = [{
            id: 'All',
            label: 'All'
        }, {
            id: 'RegistrationNo',
            label: 'Reg. No'
        }, {
            id: 'VinNo',
            label: 'Vin. No'
        }, {
            id: 'JobCardNo',
            label: 'Job Card no.'
        }];
    useEffect(function () {
        getFilterTypeList({});
    }, []);
    useEffect(function () {
        var _crud$SpareIssuesKeys4, _crud$SpareIssuesKeys5, _crud$SpareIssuesKeys6, _crud$SpareIssuesKeys7, _crud$SpareIssuesKeys8;
        if ((_crud$SpareIssuesKeys4 = crud[SpareIssuesKeys.SearchDetails]) !== null && _crud$SpareIssuesKeys4 !== void 0 && _crud$SpareIssuesKeys4.data && (_crud$SpareIssuesKeys5 = crud[SpareIssuesKeys.JobcardDetails]) !== null && _crud$SpareIssuesKeys5 !== void 0 && _crud$SpareIssuesKeys5.data && (_crud$SpareIssuesKeys6 = crud[SpareIssuesKeys.CustomerAssociationDetails]) !== null && _crud$SpareIssuesKeys6 !== void 0 && _crud$SpareIssuesKeys6.data && (_crud$SpareIssuesKeys7 = crud[SpareIssuesKeys.PartDetails]) !== null && _crud$SpareIssuesKeys7 !== void 0 && _crud$SpareIssuesKeys7.data || (_crud$SpareIssuesKeys8 = crud[SpareIssuesKeys.PartIssueDetails]) !== null && _crud$SpareIssuesKeys8 !== void 0 && _crud$SpareIssuesKeys8.data) {
            setIsFormVisible(true);
        }
    }, [crud[SpareIssuesKeys.SearchDetails], crud[SpareIssuesKeys.JobcardDetails], crud[SpareIssuesKeys.CustomerAssociationDetails], crud[SpareIssuesKeys.PartDetails], (_crud$SpareIssuesKeys9 = crud[SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys9 === void 0 ? void 0 : _crud$SpareIssuesKeys9.data]);
    var handleSearchIconClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, _response$data, request;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getSearchResultAPIcall({
                        request: (_a = {},
                            _a[filterType] = searchValue,
                            _a)
                    })];
                case 1:
                    response = _b.sent();
                    if (!(response !== null && response !== void 0 && response.success || (response === null || response === void 0 ? void 0 : response.statusCode) === 200)) return [3 /*break*/, 4];
                    searchedIstallbaseData(response === null || response === void 0 ? void 0 : response.data);
                    request = {
                        JobCardId: response !== null && response !== void 0 && response.data ? response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.JobCardId : '',
                        TenantId: selectedBranch.OrganizationId
                    };
                    if (!response.data.JobCardId) return [3 /*break*/, 3];
                    return [4 /*yield*/, getPartDetailsAPICall({
                            request: request
                        })];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    setIsFormVisible(false);
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // search function for Mobile
    var handleClickSearch = function (state, value) { return __awaiter(void 0, void 0, void 0, function () {
        var _getpartDetailsData, _getpartDetailsData2, getpartDetailsData, response, _response$data2, _response$data3, request;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getSearchResultAPIcall({
                        request: (_a = {},
                            _a[state === null || state === void 0 ? void 0 : state.Key] = state === null || state === void 0 ? void 0 : state.Value,
                            _a)
                    })];
                case 1:
                    response = _b.sent();
                    if (!(response !== null && response !== void 0 && response.success || (response === null || response === void 0 ? void 0 : response.statusCode) === 200)) return [3 /*break*/, 3];
                    searchedIstallbaseData(response === null || response === void 0 ? void 0 : response.data);
                    request = {
                        JobCardId: response !== null && response !== void 0 && response.data ? response === null || response === void 0 || (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.JobCardId : '',
                        TenantId: selectedBranch.OrganizationId
                    };
                    if (!(response !== null && response !== void 0 && (_response$data3 = response.data) !== null && _response$data3 !== void 0 && _response$data3.JobCardId)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getPartDetailsAPICall({
                            request: request
                        })];
                case 2:
                    getpartDetailsData = _b.sent();
                    _b.label = 3;
                case 3: return [2 /*return*/, _objectSpread(_objectSpread({}, (_getpartDetailsData = getpartDetailsData) === null || _getpartDetailsData === void 0 ? void 0 : _getpartDetailsData.data), {}, {
                        ProductIssueDetails: (_getpartDetailsData2 = getpartDetailsData) === null || _getpartDetailsData2 === void 0 ? void 0 : _getpartDetailsData2.data
                        // LocationDetailsName : getpartDetailsData?.data[0]?.LocationDetails
                    })];
            }
        });
    }); };
    var handleSaveClick = function (e, values) { return __awaiter(void 0, void 0, void 0, function () {
        var productIssueDetailsCopy, isValid, finalArray_1, obj_1, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    productIssueDetailsCopy = values.ProductIssueDetails;
                    setPartData(productIssueDetailsCopy);
                    delete values.Save;
                    isValid = checkIsValid(values);
                    if (!isValid) return [3 /*break*/, 2];
                    finalArray_1 = [];
                    obj_1 = {};
                    productIssueDetailsCopy === null || productIssueDetailsCopy === void 0 || productIssueDetailsCopy.map(function (item) {
                        var _item$LocationDetails, _item$LocationDetails2, _item$LocationDetails3, _item$SerialNoName;
                        obj_1 = {
                            EntityId: item === null || item === void 0 ? void 0 : item.EntityId,
                            ChildId: item === null || item === void 0 ? void 0 : item.ChildId,
                            WarehouseId: item === null || item === void 0 || (_item$LocationDetails = item.LocationDetails) === null || _item$LocationDetails === void 0 || (_item$LocationDetails = _item$LocationDetails[0]) === null || _item$LocationDetails === void 0 ? void 0 : _item$LocationDetails.WarehouseId,
                            LocationId: item === null || item === void 0 || (_item$LocationDetails2 = item.LocationDetails) === null || _item$LocationDetails2 === void 0 || (_item$LocationDetails2 = _item$LocationDetails2[0]) === null || _item$LocationDetails2 === void 0 ? void 0 : _item$LocationDetails2.LocationId,
                            LocationCode: item === null || item === void 0 || (_item$LocationDetails3 = item.LocationDetails) === null || _item$LocationDetails3 === void 0 || (_item$LocationDetails3 = _item$LocationDetails3[0]) === null || _item$LocationDetails3 === void 0 ? void 0 : _item$LocationDetails3.LocationCode,
                            SKUCode: item === null || item === void 0 ? void 0 : item.SKUCode,
                            ProductName: item === null || item === void 0 ? void 0 : item.ProductName,
                            RequestedQuantity: item === null || item === void 0 ? void 0 : item.RequestedQuantity,
                            AvailableQuantity: item === null || item === void 0 ? void 0 : item.AvailableQuantity,
                            IssueQuantity: (item === null || item === void 0 ? void 0 : item.IssueQuantity) + (item === null || item === void 0 ? void 0 : item.IssuedQuantity),
                            Qty: item === null || item === void 0 ? void 0 : item.IssueQuantity,
                            PendingQuantity: item === null || item === void 0 ? void 0 : item.PendingQuantity,
                            SerialNumber: (_item$SerialNoName = item === null || item === void 0 ? void 0 : item.SerialNoName) !== null && _item$SerialNoName !== void 0 ? _item$SerialNoName : []
                        };
                        finalArray_1.push(obj_1);
                    });
                    request = _objectSpread(_objectSpread({
                        AllocationChildId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        TransactionId: data === null || data === void 0 ? void 0 : data.JobCardId,
                        TransactionNo: data === null || data === void 0 ? void 0 : data.JobCardNo,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        RequestedDateTime: new Date().toISOString(),
                        WarehouseId: values === null || values === void 0 ? void 0 : values.WarehouseId,
                        EventType: mode === 'edit' ? 'Update' : 'Insert'
                    }, values), {}, {
                        ProductIssueDetails: finalArray_1
                    });
                    return [4 /*yield*/, spareIssueCreateAPICall({
                            request: request
                        })];
                case 1:
                    response = _a.sent();
                    if (response !== null && response !== void 0 && response.success && (response === null || response === void 0 ? void 0 : response.statusCode) === 200) {
                        setOnSavePopup(true);
                    }
                    else {
                        showNotification({
                            isOpen: true,
                            message: response === null || response === void 0 ? void 0 : response.message,
                            type: "error"
                        });
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/, 'submit'];
            }
        });
    }); };
    // onClick: () => 'submit'
    var handleSaveClickForMobileView = function (e, values) { return __awaiter(void 0, void 0, void 0, function () {
        var productIssueDetailsCopy, finalArray, obj, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    productIssueDetailsCopy = values.ProductIssueDetails;
                    setPartData(productIssueDetailsCopy);
                    delete values.Save;
                    finalArray = [];
                    obj = {};
                    productIssueDetailsCopy === null || productIssueDetailsCopy === void 0 || productIssueDetailsCopy.map(function (item) {
                        var _item$LocationDetails4, _item$LocationDetails5, _item$LocationDetails6, _item$SerialNoName2;
                        obj = {
                            EntityId: item === null || item === void 0 ? void 0 : item.EntityId,
                            ChildId: item === null || item === void 0 ? void 0 : item.ChildId,
                            WarehouseId: item === null || item === void 0 || (_item$LocationDetails4 = item.LocationDetails) === null || _item$LocationDetails4 === void 0 || (_item$LocationDetails4 = _item$LocationDetails4[0]) === null || _item$LocationDetails4 === void 0 ? void 0 : _item$LocationDetails4.WarehouseId,
                            LocationId: item === null || item === void 0 || (_item$LocationDetails5 = item.LocationDetails) === null || _item$LocationDetails5 === void 0 || (_item$LocationDetails5 = _item$LocationDetails5[0]) === null || _item$LocationDetails5 === void 0 ? void 0 : _item$LocationDetails5.LocationId,
                            LocationCode: item === null || item === void 0 || (_item$LocationDetails6 = item.LocationDetails) === null || _item$LocationDetails6 === void 0 || (_item$LocationDetails6 = _item$LocationDetails6[0]) === null || _item$LocationDetails6 === void 0 ? void 0 : _item$LocationDetails6.LocationCode,
                            SKUCode: item === null || item === void 0 ? void 0 : item.SKUCode,
                            ProductName: item === null || item === void 0 ? void 0 : item.ProductName,
                            RequestedQuantity: parseInt(item === null || item === void 0 ? void 0 : item.RequestedQuantity),
                            AvailableQuantity: parseInt(item === null || item === void 0 ? void 0 : item.AvailableQuantity),
                            IssueQuantity: parseInt(item === null || item === void 0 ? void 0 : item.IssueQuantity) + parseInt(item === null || item === void 0 ? void 0 : item.IssuedQuantity),
                            Qty: parseInt(item === null || item === void 0 ? void 0 : item.IssueQuantity),
                            PendingQuantity: parseInt(item === null || item === void 0 ? void 0 : item.PendingQuantity),
                            SerialNumber: (_item$SerialNoName2 = item === null || item === void 0 ? void 0 : item.SerialNoName) !== null && _item$SerialNoName2 !== void 0 ? _item$SerialNoName2 : []
                        };
                        finalArray.push(obj);
                    });
                    request = {
                        AllocationChildId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        TransactionId: data === null || data === void 0 ? void 0 : data.JobCardId,
                        TransactionNo: data === null || data === void 0 ? void 0 : data.JobCardNo,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        RequestedDateTime: new Date().toISOString(),
                        WarehouseId: values === null || values === void 0 ? void 0 : values.WarehouseId,
                        EventType: mode === 'edit' ? 'Update' : 'Insert',
                        // ...values,
                        ProductIssueDetails: finalArray
                    };
                    return [4 /*yield*/, spareIssueCreateAPICall({
                            request: request
                        })];
                case 1:
                    response = _a.sent();
                    if (response !== null && response !== void 0 && response.success && (response === null || response === void 0 ? void 0 : response.statusCode) === 200) {
                        setOnSavePopup(true);
                    }
                    else {
                        showNotification({
                            isOpen: true,
                            message: response === null || response === void 0 ? void 0 : response.message,
                            type: "error"
                        });
                    }
                    return [2 /*return*/, 'submit'];
            }
        });
    }); };
    var checkIsValid = function (values) {
        var isValid = false;
        if (values !== null && values !== void 0 && values.ProductIssueDetails) {
            var _values$ProductIssueD, _values$ProductIssueD2, _values$ProductIssueD3, _values$ProductIssueD4;
            var issueQtyArray = values === null || values === void 0 || (_values$ProductIssueD = values.ProductIssueDetails) === null || _values$ProductIssueD === void 0 ? void 0 : _values$ProductIssueD.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.IssueQuantity) > 0; });
            var issuedPart = values === null || values === void 0 || (_values$ProductIssueD2 = values.ProductIssueDetails) === null || _values$ProductIssueD2 === void 0 ? void 0 : _values$ProductIssueD2.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.StatusName) === SpareIssueStatusEnum.Issued; });
            var isNotIssuedParts = (values === null || values === void 0 || (_values$ProductIssueD3 = values.ProductIssueDetails) === null || _values$ProductIssueD3 === void 0 || (_values$ProductIssueD3 = _values$ProductIssueD3.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.SpareIssueStatusName) !== SpareIssueStatusEnum.Issued; })) === null || _values$ProductIssueD3 === void 0 ? void 0 : _values$ProductIssueD3.length) === 0;
            if (isNotIssuedParts || (issuedPart === null || issuedPart === void 0 ? void 0 : issuedPart.length) === (values === null || values === void 0 || (_values$ProductIssueD4 = values.ProductIssueDetails) === null || _values$ProductIssueD4 === void 0 ? void 0 : _values$ProductIssueD4.length)) {
                dispatch(showNotification({
                    isOpen: true,
                    message: 'Please issue atleast one part',
                    type: 'error'
                }));
            }
            else if (issueQtyArray.length === 0) {
                return;
            }
            else if (issueQtyArray.length > 0) {
                issueQtyArray === null || issueQtyArray === void 0 || issueQtyArray.map(function (item) {
                    var _item$SerialNumber, _item$SerialNumber2;
                    if ((item === null || item === void 0 ? void 0 : item.DefaultInventoryTrackingType) == "Serialized" && (item === null || item === void 0 ? void 0 : item.IssueQuantity) > 0 && (item === null || item === void 0 || (_item$SerialNumber = item.SerialNumber) === null || _item$SerialNumber === void 0 ? void 0 : _item$SerialNumber.length) == 0) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Please select serial no. against ".concat(item === null || item === void 0 ? void 0 : item.ProductName),
                            type: 'error'
                        }));
                    }
                    else if ((item === null || item === void 0 ? void 0 : item.DefaultInventoryTrackingType) == "Serialized" && (item === null || item === void 0 ? void 0 : item.IssueQuantity) > 0 && (item === null || item === void 0 || (_item$SerialNumber2 = item.SerialNumber) === null || _item$SerialNumber2 === void 0 ? void 0 : _item$SerialNumber2.length) !== (item === null || item === void 0 ? void 0 : item.IssueQuantity) + (item === null || item === void 0 ? void 0 : item.IssuedQuantity)) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Please select ".concat(item === null || item === void 0 ? void 0 : item.IssueQuantity, " serial no. against ").concat(item === null || item === void 0 ? void 0 : item.ProductName),
                            type: 'error'
                        }));
                    }
                    else {
                        isValid = true;
                    }
                });
            }
            else {
                isValid = true;
            }
        }
        else {
            isValid = true;
        }
        return isValid;
    };
    var General = [{
            type: FormItemTypes.Accordian,
            name: 'BasicDetails',
            columnSize: 12,
            value: false,
            summaryProps: {
                sx: {
                    display: "flex",
                    alignItems: "flex-start",
                    position: "relative",
                    paddingTop: 2
                }
            },
            sx: {
                border: '1px',
                borderRadius: "12px",
                borderColor: "#DEE4EB"
            },
            setFormState: function (formValues, currValue) {
                setIsOpen(currValue);
                return {};
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: "Basic Details",
                    children: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: "14px",
                        fontWeight: "600",
                        pt: 0
                    }, "Basic details"), !isOpen && /*#__PURE__*/ React.createElement(CardSummury, null)),
                    fontSize: "md",
                    columnSize: 12,
                    fontWeight: "strong"
                }],
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 12,
                    sx: {
                        p: 2
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: /*#__PURE__*/ React.createElement(BasicDetailcards, null),
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            name: "General",
            label: "Service Details",
            value: null,
            sx: {
                borderRadius: '12px',
                padding: 1.5,
                '& .MuiCardHeader-root': {
                    padding: '0px 0px 20px 0px !important'
                },
                '& .MuiCardContent-root': {
                    padding: 0
                }
            },
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'WarehouseId',
                    label: 'Warehouse',
                    value: null,
                    valueExpr: "id",
                    displayExpr: "DisplayName",
                    required: true,
                    getListData: getWarehouseListAPICall,
                    apiRequest: {
                        TenantId: selectedBranch.OrganizationId
                    },
                    disabled: isDisable ? isDisable : mode == 'edit' || mode == 'create' ? isNullOrEmpty(crud[SpareIssuesKeys.PartIssueDetails]) : isNullOrEmpty(crud[SpareIssuesKeys.SearchDetails])
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'IssuedBy',
                    label: 'Issued By',
                    value: "".concat((_user$data$GivenName = user === null || user === void 0 || (_user$data = user.data) === null || _user$data === void 0 ? void 0 : _user$data.GivenName) !== null && _user$data$GivenName !== void 0 ? _user$data$GivenName : "-", " ").concat((_user$data$FamilyName = user === null || user === void 0 || (_user$data2 = user.data) === null || _user$data2 === void 0 ? void 0 : _user$data2.FamilyName) !== null && _user$data$FamilyName !== void 0 ? _user$data$FamilyName : "-"),
                    multiline: true,
                    minRows: 1,
                    disabled: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'ServiceAdvisor',
                    label: 'Service Advisor',
                    placeholder: 'Service Advisor',
                    value: getGeneralDetails("ServiceAdvisor", (_crud$SpareIssuesKeys10 = (_crud$SpareIssuesKeys11 = crud[SpareIssuesKeys.JobcardDetails]) === null || _crud$SpareIssuesKeys11 === void 0 ? void 0 : _crud$SpareIssuesKeys11.data) !== null && _crud$SpareIssuesKeys10 !== void 0 ? _crud$SpareIssuesKeys10 : (_crud$SpareIssuesKeys12 = crud[SpareIssuesKeys === null || SpareIssuesKeys === void 0 ? void 0 : SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys12 === void 0 ? void 0 : _crud$SpareIssuesKeys12.data) || (installbaseData === null || installbaseData === void 0 || (_installbaseData$ = installbaseData[0]) === null || _installbaseData$ === void 0 ? void 0 : _installbaseData$.ServiceAdvisor),
                    maxLength: 100,
                    disabled: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'FloorSupervisor',
                    label: 'Floor Supervisor',
                    placeholder: 'Floor Supervisor',
                    sx: {
                        backgroundColor: '#EFF2F5',
                        borderRadius: '8px'
                    },
                    value: getGeneralDetails("FloorSupervisor", (_crud$SpareIssuesKeys13 = (_crud$SpareIssuesKeys14 = crud[SpareIssuesKeys.JobcardDetails]) === null || _crud$SpareIssuesKeys14 === void 0 ? void 0 : _crud$SpareIssuesKeys14.data) !== null && _crud$SpareIssuesKeys13 !== void 0 ? _crud$SpareIssuesKeys13 : (_crud$SpareIssuesKeys15 = crud[SpareIssuesKeys === null || SpareIssuesKeys === void 0 ? void 0 : SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys15 === void 0 ? void 0 : _crud$SpareIssuesKeys15.data) || ((_crud$SpareIssuesKeys16 = crud[SpareIssuesKeys.JobcardDetails]) === null || _crud$SpareIssuesKeys16 === void 0 || (_crud$SpareIssuesKeys16 = _crud$SpareIssuesKeys16.data) === null || _crud$SpareIssuesKeys16 === void 0 ? void 0 : _crud$SpareIssuesKeys16.FloorSupervisorName),
                    maxLength: 100,
                    disabled: true
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'Technician',
                    label: 'Technician',
                    placeholder: 'Technician',
                    value: getGeneralDetails("Technician", (_crud$SpareIssuesKeys17 = (_crud$SpareIssuesKeys18 = crud[SpareIssuesKeys.JobcardDetails]) === null || _crud$SpareIssuesKeys18 === void 0 ? void 0 : _crud$SpareIssuesKeys18.data) !== null && _crud$SpareIssuesKeys17 !== void 0 ? _crud$SpareIssuesKeys17 : (_crud$SpareIssuesKeys19 = crud[SpareIssuesKeys === null || SpareIssuesKeys === void 0 ? void 0 : SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys19 === void 0 ? void 0 : _crud$SpareIssuesKeys19.data) || ((_crud$SpareIssuesKeys20 = crud[SpareIssuesKeys.JobcardDetails]) === null || _crud$SpareIssuesKeys20 === void 0 || (_crud$SpareIssuesKeys20 = _crud$SpareIssuesKeys20.data) === null || _crud$SpareIssuesKeys20 === void 0 ? void 0 : _crud$SpareIssuesKeys20.TechnicianName),
                    maxLength: 100,
                    disabled: true
                }],
            columnSize: 12
        }, isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'partDetails',
            label: '',
            value: null,
            sx: {
                bgcolor: 'transparent',
                borderLeft: 'none',
                borderRight: 'none',
                borderRadius: '0px'
            },
            summaryProps: {
                sx: {
                    padding: 0,
                    justifyContent: 'center',
                    alignItems: 'center'
                }
            },
            summary: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    columnSize: 7,
                    columnGap: 0.5,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'partDetails',
                            label: '',
                            value: null,
                            children: 'Part details',
                            // columnSize: 0,
                            fontSize: 'base',
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'count',
                            color: 'info',
                            sx: {
                                ml: '4px'
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$ProductIs, _formValues$ProductIs2;
                                return (_formValues$ProductIs = formValues === null || formValues === void 0 || (_formValues$ProductIs2 = formValues.ProductIssueDetails) === null || _formValues$ProductIs2 === void 0 ? void 0 : _formValues$ProductIs2.length) !== null && _formValues$ProductIs !== void 0 ? _formValues$ProductIs : 0;
                            }
                        }]
                }],
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    sx: {
                        color: 'text.secondary'
                    },
                    columnSize: 12
                }, {
                    type: FormItemTypes.Button,
                    name: 'More',
                    children: /*#__PURE__*/ React.createElement(MoreVert, null),
                    size: 'small',
                    variant: 'outlined',
                    color: 'secondary',
                    sx: {
                        p: '7px',
                        ml: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end'
                    },
                    columnSize: 12,
                    setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                        var action, ProductIssueDetails, _ProductIssueDetails;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: 'Menu',
                                        containerProps: {
                                            anchorEl: e.target.parentElement
                                        },
                                        Component: ActionMenuList,
                                        componentProps: {
                                            items: [{
                                                    id: 'delete',
                                                    children: [/*#__PURE__*/ React.createElement(Delete, {
                                                            color: "secondary",
                                                            fontSize: "small"
                                                        }), "Delete"]
                                                }
                                                // {
                                                //     id: 'export',
                                                //     children: <><ExportIconSVG fontSize="small" /> Export </>
                                                // },
                                            ]
                                        }
                                    }))];
                                case 1:
                                    action = _a.sent();
                                    ProductIssueDetails = state === null || state === void 0 ? void 0 : state.ProductIssueDetails;
                                    if ((action === null || action === void 0 ? void 0 : action.payload) === 'delete') {
                                        ProductIssueDetails = (_ProductIssueDetails = ProductIssueDetails) === null || _ProductIssueDetails === void 0 ? void 0 : _ProductIssueDetails.filter(function (p) { return !p.Selected; });
                                    }
                                    return [2 /*return*/, {
                                            ProductIssueDetails: ProductIssueDetails
                                        }];
                            }
                        });
                    }); }
                }, {
                    type: FormItemTypes.List,
                    name: 'ProductIssueDetails',
                    columnSize: 12,
                    value: null,
                    containerProps: {
                        sx: {
                            mb: '16px'
                        }
                    },
                    columns: [{
                            field: 'Part',
                            flex: 1,
                            renderCell: function (_ref) {
                                var row = _ref.row;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    fontSize: "14px",
                                    fontWeight: 500
                                }, row.ChildName), /*#__PURE__*/ React.createElement(Typography, {
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    color: "secondary"
                                }, row.ChildCode ? '#' + row.ChildCode : ''));
                            }
                        }],
                    elements: spareIssuePartElements
                }],
            columnSize: 12
        } : {
            type: FormItemTypes.Custom,
            name: "ProductIssueDetails",
            label: '',
            value: [],
            element: SpareIssuePartGrid,
            validator: function (values, state) {
                var error = undefined;
                values === null || values === void 0 || values.find(function (_it) {
                    var _Object$keys;
                    var errorField = (_Object$keys = Object.keys(SEMandatoryFields)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.find(function (field) { return _it[field] === 0; });
                    if (errorField) {
                        error = {
                            id: v4(),
                            rowId: _it.id,
                            field: SEMandatoryFields[errorField],
                            message: 'Quantity must not be zero',
                            value: _it[errorField]
                        };
                    }
                    return Boolean(errorField);
                });
                return error;
            },
            columnSize: 12
        }];
    var tabs = [{
            id: '0',
            label: 'General',
            elements: General,
            containerProps: {
                padding: 2
            }
        }];
    var formData = [!isMobile ? {
            type: FormItemTypes.ContainerItem,
            name: 'pageHeader',
            columnSize: 12,
            justifyContent: 'center',
            alignItems: 'center',
            spacing: 0,
            gap: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: 'BackArrow',
                    columnSize: 0,
                    size: 'small',
                    labelTypographyProps: {
                        display: 'none'
                    },
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small"
                    }),
                    onClick: function () {
                        navigate('/spareIssues');
                        dispatch(resetState(APIKeys));
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Header',
                    children: mode == 'add' || mode == 'create' ? 'Create spare issue' : 'Spare issue',
                    columnSize: 0,
                    variant: 'h1',
                    noWrap: true,
                    labelTypographyProps: {
                        display: 'none'
                    }
                }, mode !== "add" && data !== null && data !== void 0 && data.StatusName && (data === null || data === void 0 ? void 0 : data.StatusName) !== EDashboardStatusColor.Cancelled ? {
                    type: FormItemTypes.Custom,
                    name: 'StatusCard',
                    columnSize: 0,
                    element: function () { /*#__PURE__*/ return React.createElement(Chip, _extends({
                        label: "Issued",
                        size: "small"
                    }, getStatusColor("Issued"), {
                        sx: {
                            padding: '2px 8px',
                            borderRadius: '6px'
                        }
                    })); }
                } : null, data && mode != 'add' || mode != 'create' ? {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    alignItems: 'center',
                    gap: 1,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'DOCNo',
                            label: 'DOC NO: ',
                            value: null,
                            children: (_crud$SpareIssuesKeys21 = (_crud$SpareIssuesKeys22 = crud[SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys22 === void 0 || (_crud$SpareIssuesKeys22 = _crud$SpareIssuesKeys22.data) === null || _crud$SpareIssuesKeys22 === void 0 ? void 0 : _crud$SpareIssuesKeys22.DocumentNo) !== null && _crud$SpareIssuesKeys21 !== void 0 ? _crud$SpareIssuesKeys21 : '-',
                            columnSize: 0,
                            labelTypographyProps: {
                                variant: 'subtitle2',
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                spacing: 0,
                                gap: 1,
                                mb: 0
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'DOCDate',
                            label: 'DATE: ',
                            children: dateFormate((_crud$SpareIssuesKeys23 = (_crud$SpareIssuesKeys24 = crud[SpareIssuesKeys.JobcardDetails]) === null || _crud$SpareIssuesKeys24 === void 0 || (_crud$SpareIssuesKeys24 = _crud$SpareIssuesKeys24.data) === null || _crud$SpareIssuesKeys24 === void 0 ? void 0 : _crud$SpareIssuesKeys24.CreatedOn) !== null && _crud$SpareIssuesKeys23 !== void 0 ? _crud$SpareIssuesKeys23 : (_crud$SpareIssuesKeys25 = crud[SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys25 === void 0 || (_crud$SpareIssuesKeys25 = _crud$SpareIssuesKeys25.data) === null || _crud$SpareIssuesKeys25 === void 0 ? void 0 : _crud$SpareIssuesKeys25.RequestedDateTime),
                            columnSize: 0,
                            labelTypographyProps: {
                                variant: 'subtitle2',
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                spacing: 0,
                                gap: 1
                            }
                        }]
                } : null]
        } : {
            type: FormItemTypes.ContainerItem,
            name: 'pageHeader',
            columnSize: 12,
            justifyContent: 'center',
            alignItems: 'center',
            spacing: 0,
            gap: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: 'BackArrow',
                    columnSize: 0,
                    size: 'small',
                    labelTypographyProps: {
                        display: 'none'
                    },
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small"
                    }),
                    onClick: function () {
                        navigate('/spareIssues');
                        dispatch(resetState(APIKeys));
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Header',
                    children: mode == 'add' || mode == 'create' ? 'Create spare issue' : 'Spare issue',
                    columnSize: true,
                    variant: 'h1',
                    noWrap: true,
                    labelTypographyProps: {
                        display: 'none'
                    }
                }, mode !== "add" && data !== null && data !== void 0 && data.StatusName && (data === null || data === void 0 ? void 0 : data.StatusName) !== EDashboardStatusColor.Cancelled ? {
                    type: FormItemTypes.Custom,
                    name: 'StatusCard',
                    columnSize: 0,
                    element: function () { /*#__PURE__*/ return React.createElement(Chip, _extends({
                        label: "Issued",
                        size: "small"
                    }, getStatusColor("Issued"), {
                        sx: {
                            padding: '2px 8px',
                            borderRadius: '6px'
                        }
                    })); }
                } : null, {
                    type: FormItemTypes.Typography,
                    name: 'DOCNo',
                    label: 'DOC NO: ',
                    value: null,
                    children: (_crud$SpareIssuesKeys26 = (_crud$SpareIssuesKeys27 = crud[SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys27 === void 0 || (_crud$SpareIssuesKeys27 = _crud$SpareIssuesKeys27.data) === null || _crud$SpareIssuesKeys27 === void 0 ? void 0 : _crud$SpareIssuesKeys27.DocumentNo) !== null && _crud$SpareIssuesKeys26 !== void 0 ? _crud$SpareIssuesKeys26 : '-',
                    columnSize: 12,
                    labelTypographyProps: {
                        variant: 'subtitle2',
                        mb: 0
                    },
                    containerProps: {
                        display: 'flex',
                        direction: 'row',
                        alignItems: 'center',
                        spacing: 0,
                        gap: 1,
                        mb: 0
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: 'DOCDate',
                    label: 'DOC DATE: ',
                    children: dateFormate((_crud$SpareIssuesKeys28 = (_crud$SpareIssuesKeys29 = crud[SpareIssuesKeys.JobcardDetails]) === null || _crud$SpareIssuesKeys29 === void 0 || (_crud$SpareIssuesKeys29 = _crud$SpareIssuesKeys29.data) === null || _crud$SpareIssuesKeys29 === void 0 ? void 0 : _crud$SpareIssuesKeys29.CreatedOn) !== null && _crud$SpareIssuesKeys28 !== void 0 ? _crud$SpareIssuesKeys28 : (_crud$SpareIssuesKeys30 = crud[SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys30 === void 0 || (_crud$SpareIssuesKeys30 = _crud$SpareIssuesKeys30.data) === null || _crud$SpareIssuesKeys30 === void 0 ? void 0 : _crud$SpareIssuesKeys30.RequestedDateTime) || "strervst",
                    columnSize: 12,
                    labelTypographyProps: {
                        variant: 'subtitle2',
                        mb: 0
                    },
                    containerProps: {
                        display: 'flex',
                        direction: 'row',
                        alignItems: 'center',
                        spacing: 0,
                        gap: 1
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            // py: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            bgcolor: '#EFF2F5',
            elements: [mode !== 'add' ? {
                    type: FormItemTypes.Custom,
                    name: 'JobCardNo',
                    value: (_crud$SpareIssuesKeys31 = (_crud$SpareIssuesKeys32 = crud[SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys32 === void 0 || (_crud$SpareIssuesKeys32 = _crud$SpareIssuesKeys32.data) === null || _crud$SpareIssuesKeys32 === void 0 ? void 0 : _crud$SpareIssuesKeys32.TransactionNo) !== null && _crud$SpareIssuesKeys31 !== void 0 ? _crud$SpareIssuesKeys31 : '',
                    columnSize: 4.5,
                    disabled: true
                } : !isMobile ? {
                    // Use this search for Desktop view
                    type: FormItemTypes.TextInput,
                    name: 'TransactionNo',
                    value: !isNullOrEmpty(searchValue) ? searchValue : null,
                    maxLength: 30,
                    placeholder: "Search customer by VIN, reg no, job card no",
                    columnSize: !isMobile ? 4.5 : 12,
                    focused: false,
                    setFormState: function (formValues, currValue) {
                        var _crud$SpareIssuesKeys33;
                        return {
                            ProductIssueDetails: (_crud$SpareIssuesKeys33 = crud[SpareIssuesKeys.PartIssueDetails]) === null || _crud$SpareIssuesKeys33 === void 0 ? void 0 : _crud$SpareIssuesKeys33.data
                        };
                    },
                    onChange: function (e, value) {
                        var _e$target, _e$target2;
                        setIsFormVisible(false);
                        setSearchValue(e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
                        dispatch(resetState([SpareIssuesKeys.JobcardDetails, SpareIssuesKeys.PartIssueDetails]));
                        if (value === "" || value === null || value === undefined)
                            setIsFormVisible(false);
                        if (!(e !== null && e !== void 0 && (_e$target2 = e.target) !== null && _e$target2 !== void 0 && _e$target2.value)) {
                            dispatch(setReducerState({
                                key: SpareIssuesKeys.PartDetails,
                                value: null
                            }));
                            dispatch(setReducerState({
                                key: SpareIssuesKeys.JobcardDetails,
                                value: null
                            }));
                            dispatch(setReducerState({
                                key: SpareIssuesKeys.SearchDetails,
                                value: null
                            }));
                        }
                    },
                    style: {
                        borderRadius: "8px",
                        background: "#fff",
                        marginLeft: 9.6
                    },
                    sx: {
                        '& .MuiOutlinedInput-root': {
                            paddingLeft: 0
                        }
                    },
                    InputProps: {
                        startAdornment: /*#__PURE__*/ React.createElement(MuiStack, {
                            borderRight: '1px solid #DEE4EB',
                            mx: 2,
                            width: '120px'
                        }, /*#__PURE__*/ React.createElement(Select, {
                            defaultValue: (_getSearchByTypeList$ = getSearchByTypeList === null || getSearchByTypeList === void 0 || (_getSearchByTypeList$2 = getSearchByTypeList[0]) === null || _getSearchByTypeList$2 === void 0 ? void 0 : _getSearchByTypeList$2.Value) !== null && _getSearchByTypeList$ !== void 0 ? _getSearchByTypeList$ : '',
                            sx: {
                                "& fieldset": {
                                    border: 'none',
                                    boxShadowColor: 'none',
                                    "&:root": {
                                        border: 'none',
                                        boxShadow: 'none'
                                    }
                                }
                            },
                            className: "custume-select-auto",
                            value: filterType,
                            onChange: function (e, value) {
                                var _value$props;
                                setSearchValue('');
                                setFilterType(value === null || value === void 0 || (_value$props = value.props) === null || _value$props === void 0 ? void 0 : _value$props.id);
                            },
                            id: 'searchVehicleDropDown'
                        }, searchType === null || searchType === void 0 ? void 0 : searchType.map(function (item, index) { /*#__PURE__*/ return React.createElement(MenuItem, {
                            id: item.id,
                            key: index,
                            value: item.id
                        }, item.label); }))),
                        endAdornment: /*#__PURE__*/ React.createElement(IconButton, {
                            onClick: handleSearchIconClick,
                            disabled: isSearchDisabled,
                            sx: {
                                opacity: isSearchDisabled ? 0.4 : "none"
                            }
                        }, /*#__PURE__*/ React.createElement("img", {
                            src: SearchIcon,
                            alt: ""
                        }))
                    }
                } : {
                    //use this search for mobile
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    ml: 2,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'White',
                    width: '100%',
                    maxWidth: 400,
                    elements: [{
                            type: FormItemTypes.SingleSelect,
                            name: 'Key',
                            value: searchType[0].id,
                            options: searchType,
                            displayExpr: 'label',
                            variant: 'standard',
                            disableUnderline: true,
                            sx: {
                                minWidth: 90
                            },
                            columnSize: 0
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'Value',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Search by Reg No, VIN, Mobile, Email',
                            InputProps: {
                                disableUnderline: true
                            },
                            valueSetter: function (state, currValue, field) {
                                var _a;
                                return (_a = {},
                                    _a[field.name] = currValue === null || currValue === void 0 ? void 0 : currValue.trim(),
                                    _a);
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: 'searchButton',
                            columnSize: 0,
                            color: 'secondary',
                            children: /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            }),
                            setFormState: handleClickSearch
                        }]
                }, !isMobile ? {
                    type: FormItemTypes.ContainerItem,
                    name: 'QuickLink',
                    label: '',
                    value: null,
                    columnSize: 7,
                    justifyContent: 'flex-end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'quick-links',
                            children: 'Quick Links',
                            disabled: isDisable,
                            columnSize: 0,
                            variant: 'text',
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            sx: {
                                background: 'none'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'DownloadIcon',
                            disabled: isDisable,
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            sx: {
                                p: 1
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'ShareIcon',
                            disabled: isDisable,
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary',
                            sx: {
                                p: 1
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'PrintIcon',
                            label: '',
                            value: null,
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            disabled: isDisable,
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary',
                            sx: {
                                p: 1
                            }
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 0,
                            height: '100%',
                            width: '1px',
                            bgcolor: 'rgba(0,0,0,0.1)',
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: 'PrintIcon',
                            label: '',
                            value: null,
                            children: /*#__PURE__*/ React.createElement(CrossSvgIcon, null),
                            columnSize: 0,
                            color: 'secondary',
                            variant: 'outlined',
                            disabled: isDisable,
                            sx: {
                                p: 1
                            }
                        },
                        // {
                        //     type: FormItemTypes.Button,
                        //     name: 'SaveAsDraft',
                        //     children: 'Save as draft',
                        //     columnSize: 0,
                        //     variant: 'outlined',
                        //     disabled: isDisable
                        // },
                        {
                            type: FormItemTypes.Button,
                            name: 'Save',
                            children: 'Save',
                            id: 'save',
                            columnSize: 0,
                            variant: isDisable ? 'outlined' : 'contained',
                            disabled: isDisable,
                            onClick: handleSaveClick
                        }]
                } : null]
        }, isFormVisible ? {
            type: FormItemTypes.Tabs,
            name: 'tabs',
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            columnSize: 12,
            sx: {
                px: 2
            },
            tabProps: {
                sx: {
                    padding: 2,
                    textTransform: "none"
                }
            }
        } : null, isFormVisible && isMobile ? {
            type: FormItemTypes.Box,
            name: '',
            display: 'flex',
            columnSize: 12,
            position: 'sticky',
            bottom: 0,
            right: 0,
            bgcolor: 'white',
            p: 1.2,
            width: '100%',
            justifyContent: 'end',
            sx: {
                borderTop: '1px solid ',
                borderColor: systemColor.grey,
                gap: '16px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    id: "createDocument",
                    name: '',
                    children: "Save",
                    variant: 'contained',
                    color: 'primary',
                    columnSize: 0,
                    onClick: handleSaveClickForMobileView
                    // onClick: (e, state, api) => {
                    //     if (api?.errors?.isError) {
                    //         dispatch(
                    //             showNotification({
                    //                 isOpen: true,
                    //                 message: "Please fill mandatory fields.",
                    //                 type: "error"
                    //             })
                    //         );
                    //     } else {
                    //         return 'submit'
                    //     }
                    // }
                }]
        } : null];
    return /*#__PURE__*/ React.createElement(Grid, {
        bgcolor: faintblue
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        getFormAPI: getSpareIssueDetails(id, tenantId, mode),
        createKey: SpareIssuesKeys.Create
        // createFormAPI={spareIssueCreateAPICall}
        // createRequest={{}}
        ,
        gridSpacing: 0
    }), onSavePopup && /*#__PURE__*/ React.createElement(SavedSuccessfullyPopup, {
        openPopUp: onSavePopup,
        setOpenPopUp: function (prev) { return setOnSavePopup(prev); },
        onClosePopup: function () { return setOnSavePopup(false); },
        headerTitle: "Saved succuessfully !",
        documentName: "Spare Issue",
        documentNo: (_crud$SpareIssuesKeys34 = crud[SpareIssuesKeys.Create]) === null || _crud$SpareIssuesKeys34 === void 0 || (_crud$SpareIssuesKeys34 = _crud$SpareIssuesKeys34.data) === null || _crud$SpareIssuesKeys34 === void 0 ? void 0 : _crud$SpareIssuesKeys34.DocumentNo,
        partData: partData,
        createNewDocument: function () {
            dispatch(resetState(APIKeys));
            setOnSavePopup(false);
        },
        pagingNavigation: "/spareIssues"
    }), /*#__PURE__*/ React.createElement(Backdrop, {
        sx: function (theme) { return ({
            color: '#fff',
            zIndex: theme.zIndex.drawer + 1
        }); },
        open: Boolean(isLoadingState([SpareIssuesKeys.Create, SpareIssuesKeys.PartDetails, SpareIssuesKeys.SearchDetails, SpareIssuesKeys.CustomerAssociationDetails, SpareIssuesKeys.Installbasedetails, SpareIssuesKeys.JobcardDetails, SpareIssuesKeys.PartIssueDetails]))
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        color: "inherit"
    })));
};
